const $$splitComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_main/admin/user/search.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { UserAccountFilterParamSchema } from '@apps/main/features/admin/pages/user/search-schema';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_main/admin/user/search')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: UserAccountFilterParamSchema
});